export default __webpack_public_path__ + "static/media/Ch3b.05f804e7.gif";